import { render, staticRenderFns } from "./BalanceDepositTransaction.vue?vue&type=template&id=a4f04f10&scoped=true&"
import script from "./BalanceDepositTransaction.vue?vue&type=script&lang=js&"
export * from "./BalanceDepositTransaction.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDepositTransaction.vue?vue&type=style&index=0&id=a4f04f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f04f10",
  null
  
)

export default component.exports